/**
 * Stable ids for the questions in `GUIDED_QUESTIONS`. Shared so producers (the
 * question list) and consumers (the guided companion, the adaptive-intake flow,
 * analytics) reference one source of truth instead of repeating the raw string.
 */
export enum GuidedQuestionId {
  CONCERNS = 'concerns',
  GENDER = 'gender',
  AGE = 'age',
  TREATMENT_APPROACH = 'treatment-approach'
}
